import {User} from "../../../../../pages/shared/models/user/user";
import React, {useEffect, useState} from "react";
import BarekamText from "../../../../../pages/components/text";
import {Message, MessageSections} from "../../../../../pages/components/message/message";
import BarekamPagination from "../../../../../pages/orders/my/pagination/barekam-pagination";
import {FilesResponseModel} from "../../../../../pages/shared/models/api/files-response.model";
import fileService from "../../../../../services/file-service";
import {BarekamAttachment} from "../../../../../pages/components/attachment/attachment";
import {CustomerPageEmpty} from "../../../../../pages/user/monthly-limits/styled";

const CustomerFiles = ({customer}: {customer: User | undefined}) => {
    const [isLoading, setIsLoading] = useState(true);
    const [filesData, setFilesData] = useState({
        currentPage: 0,
        files: [],
        pageSize: 10,
        totalItems: 0,
    } as FilesResponseModel);

    useEffect(() => {
        if (customer?.userId) {
            loadFiles(customer.userId, filesData.currentPage);
        }
    }, [customer])

    function loadFiles(userId: number, page: number) {
        fileService.getUserFiles(userId, page, filesData.pageSize)
            .then(response => {
                if (response) {
                    setFilesData(response);
                }
                setIsLoading(false);
            })
    }

    function handlePageChange (event: unknown, newPage: number) {
        if (customer?.userId) {
            loadFiles(customer.userId, newPage - 1);
        }
    }

    if (isLoading) {
        return (
            <></>
        )
    } else {
        return (
            <>
                <BarekamAttachment titleLabel={<></>}
                                   values={filesData.files}
                                   isSingle={false}
                                   isReadonly={true}/>

                {filesData.totalItems > filesData.pageSize
                    ? <BarekamPagination {...filesData} onPageChange={handlePageChange}/>
                    : <></>
                }

                {filesData.files.length
                    ? <></>
                    : <CustomerPageEmpty>
                        <BarekamText variant={"xxl"} align={"center"} bold opaque>
                            <Message messageKey={'no_uploads'} sectionId={MessageSections.USER}/>
                        </BarekamText>
                    </CustomerPageEmpty>
                }
            </>
        )
    }
};

export default CustomerFiles;
